(function (angular) {
    angular.module('bizPartEngage').service('core.registerService', registerService);

    registerService.$inject = ["$http"];

    function registerService($http) {

        this.CreateUser = function (user) {
            return $http.post(siteRootPath + 'api/user/CreateUser', { user: user });
        };        

        this.GetConfiguration = function () {
            return $http.get(siteRootPath + 'api/user/GetPublicUserRegistrationConfiguration');
        };
    }

})(window.angular);
